<template>
  <transition
    appear
    key="mobile-menu"
    name="menu"
    @enter="onMenuEnter"
    @after-enter="showMenuItems"
  >
    <div
      v-if="isMobileOpen"
      :class="[
        'absolute top-0 left-0 bg-secondary w-full h-screen pt-header-main-mobile',
      ]"
    >
      <div class="w-full h-full flex flex-col">
        <div class="h-full relative">
          <!-- MAIN MENU -->
          <transition
            appear
            key="menu"
            name="menu"
            @enter="onMenuEnter"
            @after-enter="showMenuItems"
          >
            <div
              v-if="isMobileOpen"
              class="w-full h-full absolute top-0 left-0 bg-secondary"
            >
              <div
                class="o-wrapper pt-6 h-full overflow-y-auto overflow-x-hidden mb-6"
              >
                <nav>
                  <ul class="text-none list-none">
                    <li
                      v-for="(navItem, index) in mainMenu.progressiveItems"
                      :key="navItem.id"
                      :class="['flex items-center', index === 0 ? '' : 'mt-4']"
                      data-stagger-item
                    >
                      <button
                        :class="[
                          'group relative inline-flex items-center h-8',
                          navItem.classes,
                        ]"
                        aria-label="`Open ${navItem.title} menu`"
                        @click="activeSubMenuId = navItem.id"
                      >
                        <p
                          class="u-body-lg font-bold text-grey-800 focus:outline-none"
                        >
                          <span
                            :class="[
                              'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                            ]"
                          ></span>
                          <span
                            :class="[
                              'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                            ]"
                          >
                            {{ navItem.title }}
                          </span>
                        </p>
                        <Sprite
                          id="icon-chevron-right"
                          class="block w-8 h-8 ml-3 text-primary"
                        />
                      </button>
                    </li>
                  </ul>

                  <span
                    class="block w-[50px] h-[1px] bg-black my-6"
                    data-stagger-item
                  ></span>

                  <ul class="text-none list-none mb-6">
                    <li
                      v-for="(navItem, index) in mainMenu.linkItems"
                      :key="navItem.id"
                      :class="['flex items-center', index === 0 ? '' : 'mt-4']"
                      data-stagger-item
                    >
                      <a
                        :href="navItem.url"
                        :target="navItem.newWindow ? '_blank' : '_self'"
                        :class="[
                          'u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none',
                          navItem.classes,
                        ]"
                      >
                        <span
                          :class="[
                            'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                          ]"
                        ></span>
                        <span
                          :class="[
                            'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                          ]"
                        >
                          {{ navItem.title }}
                        </span>
                      </a>
                    </li>
                  </ul>

                  <ul class="text-none list-none mb-6">
                    <li
                      v-for="(navItem, index) in additionalNav"
                      :key="navItem.id"
                      :class="['flex items-center', index === 0 ? '' : 'mt-4']"
                      data-stagger-item
                    >
                      <a
                        :href="navItem.url"
                        target="_self"
                        class="u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none"
                      >
                        <Sprite
                          :id="navItem.icon"
                          class="block w-6 h-6 mr-3 text-grey-800"
                        />
                        <span
                          :class="[
                            'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                          ]"
                        ></span>
                        <span
                          :class="[
                            'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                          ]"
                        >
                          {{ navItem.title }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </transition>
          <!--  -->

          <!-- SUB MENUS -->
          <transition
            appear
            name="sub-menu"
            @enter="onMenuEnter"
            @after-enter="showMenuItems"
            v-for="subMenu in subMenus"
            :key="`sub-menu-${subMenu.id}`"
          >
            <div
              v-if="isMobileOpen && activeSubMenuId === subMenu.id"
              class="w-full h-full absolute top-0 left-0 bg-secondary"
            >
              <div
                class="o-wrapper pt-6 h-full overflow-y-auto overflow-x-hidden"
              >
                <!-- BACK BUTTON -->
                <button
                  type="button"
                  :class="[
                    'u-body-sm group relative inline-flex items-center h-8 text-grey-800 font-bold focus:outline-none mb-4',
                  ]"
                  aria-label="`Close ${subMenu.title} menu`"
                  @click="resetActiveSubMenu"
                >
                  <span
                    :class="[
                      'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                    ]"
                  ></span>
                  <span class="block w-4 h-8 relative mr-3">
                    <Sprite
                      id="icon-chevron-right"
                      class="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-8 text-primary transform rotate-180"
                    />
                  </span>
                  <span
                    :class="[
                      'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                    ]"
                  >
                    {{ subMenu.title }}
                  </span>
                </button>
                <!--  -->

                <nav>
                  <!-- PROGRESSIVE ITEMS -->
                  <div v-if="subMenu.children.progressiveItems.length > 0">
                    <ul class="text-none list-none">
                      <li
                        v-for="(navItem, index) in subMenu.children
                          .progressiveItems"
                        :key="navItem.id"
                        :class="[
                          'flex items-center',
                          index === 0 ? '' : 'mt-4',
                        ]"
                        data-stagger-item
                      >
                        <button
                          :class="[
                            'group relative inline-flex items-center h-8',
                            navItem.classes,
                          ]"
                          aria-label="`Open ${navItem.title} menu`"
                          @click="activeSubSubMenuId = navItem.id"
                        >
                          <p
                            class="u-body-lg font-bold text-grey-800 focus:outline-none"
                          >
                            <span
                              :class="[
                                'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                              ]"
                            ></span>
                            <span
                              :class="[
                                'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                              ]"
                            >
                              {{ navItem.title }}
                            </span>
                          </p>
                          <Sprite
                            id="icon-chevron-right"
                            class="block w-8 h-8 ml-3 text-primary"
                          />
                        </button>
                      </li>

                      <li
                        v-if="subMenu.url"
                        class="flex items-center mt-4"
                        data-stagger-item
                      >
                        <a
                          :href="subMenu.url"
                          class="u-body-lg font-bold text-grey-800 focus:outline-none"
                        >
                          <span
                            :class="[
                              'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                            ]"
                          ></span>
                          <span
                            :class="[
                              'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                            ]"
                          >
                            Explore all
                          </span>
                        </a>
                      </li>
                    </ul>

                    <span
                      class="block w-[50px] h-[1px] bg-black my-6"
                      data-stagger-item
                    ></span>
                  </div>
                  <!--  -->

                  <!-- LINK GROUPS -->
                  <template v-if="subMenu.children.linkGroups.length > 0">
                    <div
                      v-for="(linkGroup, index) in subMenu.children.linkGroups"
                      :key="linkGroup.id"
                    >
                      <p class="u-body-sm text-grey-800 mb-3" data-stagger-item>
                        {{ linkGroup.title }}
                      </p>

                      <ul class="text-none list-none mb-6">
                        <li
                          v-for="(navItem, itemIndex) in linkGroup.children"
                          :key="navItem.id"
                          :class="[
                            'flex items-center',
                            itemIndex === 0 ? '' : 'mt-2',
                          ]"
                          data-stagger-item
                        >
                          <a
                            :href="navItem.url"
                            target="_self"
                            class="u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none"
                          >
                            <span
                              :class="[
                                'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                              ]"
                            ></span>
                            <span
                              :class="[
                                'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                              ]"
                            >
                              {{ navItem.title }}
                            </span>
                          </a>
                        </li>
                      </ul>

                      <span
                        v-if="index !== subMenu.children.linkGroups.length - 1"
                        class="block w-[50px] h-[1px] bg-black my-6"
                        data-stagger-item
                      ></span>
                    </div>
                  </template>
                  <!-- LINK GROUPS -->

                  <!-- LINK ITEMS -->
                  <div v-if="subMenu.children.linkItems.length > 0">
                    <ul class="text-none list-none mb-6">
                      <li
                        v-for="(navItem, index) in subMenu.children.linkItems"
                        :key="navItem.id"
                        :class="[
                          'flex items-center',
                          index === 0 ? '' : 'mt-4',
                        ]"
                        data-stagger-item
                      >
                        <a
                          :href="navItem.url"
                          :target="navItem.newWindow ? '_blank' : '_self'"
                          :class="[
                            'u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none',
                            navItem.classes,
                          ]"
                        >
                          <span
                            :class="[
                              'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                            ]"
                          ></span>
                          <span
                            :class="[
                              'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                            ]"
                          >
                            {{ navItem.title }}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <!--  -->
                </nav>

                <div
                  v-if="
                    subMenu.attributes &&
                    subMenu.attributes.communityPostcodeSearch
                  "
                  class="p-5 bg-white rounded-lg"
                  data-stagger-item
                >
                  <p class="u-body-md text-grey-800 text-center mb-3">
                    Find the perfect community
                  </p>
                  <NearbyInput
                    type="communities"
                    placeholder="Enter your postcode"
                    :communities="communities"
                    :nearbyRedirectUrl="findCommunitiesUrl"
                  />
                </div>

                <div
                  v-if="
                    subMenu.attributes && subMenu.attributes.homesPostcodeSearch
                  "
                  class="p-5 bg-white rounded-lg"
                  data-stagger-item
                >
                  <p class="u-body-md text-grey-800 text-center mb-3">
                    Find the perfect home
                  </p>
                  <NearbyInput
                    type="homesForSale"
                    placeholder="Enter your postcode"
                    :communities="communities"
                    :nearbyRedirectUrl="findHomesUrl"
                  />
                </div>
              </div>
            </div>
          </transition>
          <!--  -->

          <!-- SUB SUB MENUS -->
          <transition
            appear
            name="sub-menu"
            @enter="onMenuEnter"
            @after-enter="showMenuItems"
            v-for="subSubMenu in subSubMenus"
            :key="`sub-sub-menu-${subSubMenu.id}`"
          >
            <div
              v-if="isMobileOpen && activeSubSubMenuId === subSubMenu.id"
              class="w-full h-full absolute top-0 left-0 bg-secondary"
            >
              <div
                class="o-wrapper pt-6 h-full overflow-y-auto overflow-x-hidden"
              >
                <!-- BACK BUTTON -->
                <button
                  type="button"
                  :class="[
                    'u-body-sm group relative inline-flex items-center h-8 text-grey-800 font-bold focus:outline-none mb-4',
                  ]"
                  aria-label="`Close ${subSubMenu.title} menu`"
                  @click="resetActiveSubSubMenu"
                >
                  <span
                    :class="[
                      'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                    ]"
                  ></span>
                  <span class="block w-4 h-8 relative mr-3">
                    <Sprite
                      id="icon-chevron-right"
                      class="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-8 text-primary transform rotate-180"
                    />
                  </span>
                  <span
                    :class="[
                      'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                    ]"
                  >
                    {{ subSubMenu.title }}
                  </span>
                </button>
                <!--  -->

                <nav>
                  <ul class="text-none list-none mb-6">
                    <li
                      v-for="(navItem, index) in subSubMenu.children"
                      :key="navItem.id"
                      :class="['flex items-center', index === 0 ? '' : 'mt-4']"
                      data-stagger-item
                    >
                      <a
                        :href="navItem.url"
                        :target="navItem.newWindow ? '_blank' : '_self'"
                        :class="[
                          'u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none',
                          navItem.classes,
                        ]"
                      >
                        <span
                          :class="[
                            'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                          ]"
                        ></span>
                        <span
                          :class="[
                            'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                          ]"
                        >
                          {{ navItem.title }}
                        </span>

                        <span
                          v-if="navItem.tag !== null"
                          class="u-body-sm font-bold bg-white border-1 border-solid border-grey-700 py-1 px-2 rounded-md ml-2"
                          >{{ navItem.tag }}</span
                        >
                      </a>
                    </li>

                    <li
                      v-if="subSubMenu.url"
                      class="flex items-center mt-4"
                      data-stagger-item
                    >
                      <a
                        :href="subSubMenu.url"
                        :target="subSubMenu.newWindow ? '_blank' : '_self'"
                        :class="[
                          'u-body-md group relative inline-flex items-center h-8 font-bold text-grey-800 focus:outline-none',
                          subSubMenu.classes,
                        ]"
                      >
                        <span
                          :class="[
                            'absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none',
                          ]"
                        ></span>
                        <span
                          :class="[
                            'group-hover:border-current border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out',
                          ]"
                        >
                          Explore all
                        </span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </transition>
          <!--  -->
        </div>

        <div class="px-5 py-8">
          <div class="flex justify-center gap-x-3" data-stagger-item>
            <CtaButton
              buttonType="primary"
              :label="enquireCtaLabel"
              :url="enquireCtaUrl"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import gsap from 'gsap';
import { flatten } from 'lodash';

import Sprite from '../../../Sprite';
import CtaButton from '../../../CtaButton';
import NearbyInput from '../../../NearbyInput';

export default {
  components: {
    Sprite,
    CtaButton,
    NearbyInput,
  },
  props: {
    isMobileOpen: {
      type: Boolean,
      required: true,
    },
    nav: {
      type: Array,
      required: true,
    },
    communities: {
      type: Array,
      required: true,
    },
    enquireCtaLabel: {
      type: String,
      required: true,
    },
    enquireCtaUrl: {
      type: String,
      required: true,
    },
    savedUrl: {
      type: String,
      required: true,
    },
    searchUrl: {
      type: String,
      required: true,
    },
    findCommunitiesUrl: {
      type: String,
      required: true,
    },
    findHomesUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeSubMenuId: '',
      activeSubSubMenuId: '',
      additionalNav: [
        {
          id: 'newsletter',
          url: '/newsletter',
          title: 'Subscribe to updates',
          icon: 'icon-mail',
        },
        {
          id: 'saved',
          url: '/saved',
          title: 'Saved',
          icon: 'icon-heart-2',
        },
        {
          id: 'search',
          url: '/search',
          title: 'Search',
          icon: 'icon-search',
        },
      ],
    };
  },
  computed: {
    mainMenu() {
      return {
        progressiveItems: this.nav.filter(
          (item) => item.attributes?.progressiveItem
        ),
        linkItems: this.nav.filter((item) => !item.attributes?.progressiveItem),
      };
    },
    subMenus() {
      return this.nav
        .filter((item) => item.children)
        .map((subMenu) => {
          const children = {
            progressiveItems: subMenu.children.filter(
              (item) => item.attributes?.progressiveItem
            ),
            linkGroups: subMenu.children.filter(
              (item) =>
                item.type === 'passive' && !item.attributes?.progressiveItem
            ),
            linkItems: subMenu.children.filter(
              (item) =>
                item.type !== 'passive' && !item.attributes?.progressiveItem
            ),
          };

          return {
            id: subMenu.id,
            title: subMenu.title,
            url: subMenu.url,
            newWindow: subMenu.newWindow,
            classes: subMenu.classes,
            attributes: subMenu.attributes,
            children,
          };
        });
    },
    subSubMenus() {
      return flatten(
        this.subMenus
          .filter((subMenu) => subMenu.children?.progressiveItems.length > 0)
          .map((subMenu) => {
            return subMenu.children.progressiveItems.map((subSubMenu) => {
              return {
                id: subSubMenu.id,
                title: subSubMenu.title,
                url: subSubMenu.url,
                newWindow: subSubMenu.newWindow,
                classes: subSubMenu.classes,
                attributes: subSubMenu.attributes,
                children: subSubMenu.children,
              };
            });
          })
      );
    },
  },
  methods: {
    onMenuEnter(el, done) {
      setTimeout(() => {
        done();
      }, 200);

      el.timeline = gsap.timeline({
        defaults: {
          duration: 0.5,
          ease: 'power2.inOut',
        },
      });

      const staggerItems = Array.from(
        el.querySelectorAll('[data-stagger-item]')
      );

      el.timeline.set(staggerItems, { x: 50, opacity: 0 });
    },
    showMenuItems(el) {
      const staggerItems = Array.from(
        el.querySelectorAll('[data-stagger-item]')
      );

      el.timeline.to(staggerItems, { x: 0, opacity: 1, stagger: 0.1 }, '+=0');
      el.timeline.play();
    },
    resetActiveSubMenu() {
      this.activeSubMenuId = '';
    },
    resetActiveSubSubMenu() {
      this.activeSubSubMenuId = '';
    },
    resetAllActiveSubMenus() {
      this.activeSubMenuId = '';
      this.activeSubSubMenuId = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-enter-active {
  @apply transition-all duration-200 ease-in-out;
}
.menu-leave-active {
  @apply transition-all duration-200 ease-in-out;
}
.menu-enter,
.menu-leave-to {
  @apply -translate-y-8 opacity-0;
}
.menu-enter-to,
.menu-leave {
  @apply translate-y-0 opacity-100;
}

.sub-menu-enter-active {
  transition: all 200ms ease-in-out;
}
.sub-menu-leave-active {
  transition: all 200ms ease-in-out;
}
.sub-menu-enter,
.sub-menu-leave-to {
  transform: translateX(100%);
}

.megamenu {
  @apply opacity-0 -translate-y-full pointer-events-none;
  transition: opacity 200ms theme('transitionTimingFunction.in-out'),
    transform 200ms theme('transitionTimingFunction.in-out') 100ms;
}

.group-megamenu:hover .megamenu,
.group-megamenu:focus-within .megamenu {
  @apply opacity-100 translate-y-0 pointer-events-auto;
  transition: opacity 200ms theme('transitionTimingFunction.in-out') 100ms,
    transform 200ms theme('transitionTimingFunction.in-out');
}
</style>
